(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('muas-collection-load-more')) {
    customElements.define(
      'muas-collection-load-more',
      class extends HTMLElement {
        connectedCallback() {
          this.grid = this.querySelector('#product-grid');
          this.link = this.querySelector('[data-muas-load-more]');

          if (!this.grid || !this.link || this.dataset.ready === 'true') return;

          this.dataset.ready = 'true';
          this.defaultLabel = this.link.textContent.trim();
          this.soldOutItems = [];
          this.shouldKeepSoldOutLast =
            this.dataset.soldOutLast === 'true' &&
            !new URLSearchParams(window.location.search).has('filter.v.availability');

          if (this.shouldKeepSoldOutLast) {
            Array.from(this.grid.children).forEach((item) => {
              if (item.dataset.muasProductAvailable === 'false') {
                this.soldOutItems.push(item);
                item.remove();
              }
            });
          }

          this.onLoadMore = this.onLoadMore.bind(this);
          this.link.addEventListener('click', this.onLoadMore);
        }

        async onLoadMore(event) {
          event.preventDefault();
          if (this.loading) return;

          this.loading = true;
          this.link.setAttribute('aria-busy', 'true');
          this.link.textContent = this.link.dataset.loadingLabel;

          try {
            const requestUrl = new URL(this.link.href, window.location.origin);
            requestUrl.searchParams.set('section_id', this.dataset.sectionId);

            const response = await fetch(requestUrl.toString(), {
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              }
            });

            if (!response.ok) throw new Error('Collection products could not be loaded');

            const responseText = await response.text();
            const responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
            const incomingElement = responseDocument.querySelector('muas-collection-load-more');
            const incomingGrid = incomingElement?.querySelector('#product-grid');

            if (!incomingElement || !incomingGrid) {
              throw new Error('Collection product grid was not found');
            }

            const incomingItems = Array.from(incomingGrid.children);

            if (this.shouldKeepSoldOutLast) {
              const availableItems = incomingItems.filter(
                (item) => item.dataset.muasProductAvailable === 'true'
              );
              const soldOutItems = incomingItems.filter(
                (item) => item.dataset.muasProductAvailable === 'false'
              );

              availableItems.forEach((item) => {
                this.grid.appendChild(item);
              });

              soldOutItems.forEach((item) => {
                this.soldOutItems.push(item);
              });
            } else {
              incomingItems.forEach((item) => {
                this.grid.appendChild(item);
              });
            }

            const nextLink = incomingElement.querySelector('[data-muas-load-more]');

            if (nextLink) {
              const nextUrl = new URL(nextLink.getAttribute('href'), window.location.origin);
              nextUrl.searchParams.delete('section_id');
              this.link.href = nextUrl.toString();
              this.link.textContent = this.defaultLabel;
              this.link.removeAttribute('aria-busy');
            } else {
              this.soldOutItems.forEach((item) => {
                this.grid.appendChild(item);
              });
              this.soldOutItems = [];
              this.querySelector('.muas-collection-load-more')?.remove();
            }
          } catch (error) {
            const fallbackUrl = new URL(this.link.href, window.location.origin);
            fallbackUrl.searchParams.delete('section_id');
            window.location.assign(fallbackUrl.toString());
          } finally {
            this.loading = false;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muas-banner-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('muas-banner-products')) {
    customElements.define(
      'muas-banner-products',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-banner-track]');
          this.previousButton = this.querySelector('[data-banner-previous]');
          this.nextButton = this.querySelector('[data-banner-next]');
          this.progress = this.querySelector('[data-banner-progress]');
          this.progressThumb = this.querySelector('[data-banner-progress-thumb]');
          if (!this.track) return;
          this.updateProgress = this.updateProgress.bind(this);
          this.onPointerDown = this.onPointerDown.bind(this);
          this.onPointerMove = this.onPointerMove.bind(this);
          this.onPointerUp = this.onPointerUp.bind(this);
          this.onTrackClick = this.onTrackClick.bind(this);
          this.onDragStart = (event) => event.preventDefault();
          this.onPreviousClick = () => this.move(-1);
          this.onNextClick = () => this.move(1);
          this.onScroll = () => window.requestAnimationFrame(this.updateProgress);
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.addEventListener('pointerdown', this.onPointerDown);
          this.track.addEventListener('pointermove', this.onPointerMove);
          this.track.addEventListener('pointerup', this.onPointerUp);
          this.track.addEventListener('pointercancel', this.onPointerUp);
          this.track.addEventListener('click', this.onTrackClick, true);
          this.track.addEventListener('dragstart', this.onDragStart);
          window.addEventListener('resize', this.updateProgress);
          if (this.previousButton) this.previousButton.addEventListener('click', this.onPreviousClick);
          if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);
          window.requestAnimationFrame(this.updateProgress);
        }

        disconnectedCallback() {
          if (!this.track) return;
          this.track.removeEventListener('scroll', this.onScroll);
          this.track.removeEventListener('pointerdown', this.onPointerDown);
          this.track.removeEventListener('pointermove', this.onPointerMove);
          this.track.removeEventListener('pointerup', this.onPointerUp);
          this.track.removeEventListener('pointercancel', this.onPointerUp);
          this.track.removeEventListener('click', this.onTrackClick, true);
          this.track.removeEventListener('dragstart', this.onDragStart);
          window.removeEventListener('resize', this.updateProgress);
          if (this.previousButton) this.previousButton.removeEventListener('click', this.onPreviousClick);
          if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
        }

        onPointerDown(event) {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.isPointerDragging = true;
          this.dragMoved = false;
          this.dragStartX = event.clientX;
          this.dragStartScrollLeft = this.track.scrollLeft;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
        }

        onPointerMove(event) {
          if (!this.isPointerDragging) return;
          const distance = event.clientX - this.dragStartX;
          if (Math.abs(distance) > 5) this.dragMoved = true;
          this.track.scrollLeft = this.dragStartScrollLeft - distance;
        }

        onPointerUp(event) {
          if (!this.isPointerDragging) return;
          this.isPointerDragging = false;
          this.track.classList.remove('is-dragging');
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
          window.setTimeout(() => {
            this.dragMoved = false;
          }, 0);
        }

        onTrackClick(event) {
          if (!this.dragMoved) return;
          event.preventDefault();
          event.stopPropagation();
        }

        move(direction) {
          const card = this.track.querySelector('.muas-banner-product-card');
          if (!card) return;
          const styles = window.getComputedStyle(this.track);
          const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
          this.track.scrollBy({
            left: direction * (card.getBoundingClientRect().width + gap),
            behavior: 'smooth'
          });
        }

        updateProgress() {
          if (!this.progress || !this.progressThumb) return;
          const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const visibleRatio = Math.min(1, this.track.clientWidth / this.track.scrollWidth);
          const scrollRatio = maximumScroll > 0 ? this.track.scrollLeft / maximumScroll : 0;
          const thumbWidth = Math.max(44, this.progress.clientWidth * visibleRatio);
          const maximumTravel = Math.max(0, this.progress.clientWidth - thumbWidth);
          this.progressThumb.style.width = `${thumbWidth}px`;
          this.progressThumb.style.transform = `translateX(${maximumTravel * scrollRatio}px)`;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muas-product-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('muas-carousel')) {
    customElements.define(
      'muas-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-carousel-track]');
          this.previousButton = this.querySelector('[data-carousel-previous]');
          this.nextButton = this.querySelector('[data-carousel-next]');
          this.progress = this.querySelector('[data-carousel-progress]');
          this.progressThumb = this.querySelector('[data-carousel-progress-thumb]');
          if (!this.track) return;
          this.updateProgress = this.updateProgress.bind(this);
          this.onScroll = () => window.requestAnimationFrame(this.updateProgress);
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.updateProgress);
          if (this.previousButton) this.previousButton.addEventListener('click', () => this.move(-1));
          if (this.nextButton) this.nextButton.addEventListener('click', () => this.move(1));
          window.requestAnimationFrame(this.updateProgress);
        }

        disconnectedCallback() {
          if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
          if (this.updateProgress) window.removeEventListener('resize', this.updateProgress);
        }

        move(direction) {
          const card = this.track.querySelector('.muas-product-card');
          if (!card) return;
          const styles = window.getComputedStyle(this.track);
          const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
          this.track.scrollBy({
            left: direction * (card.getBoundingClientRect().width + gap),
            behavior: 'smooth'
          });
        }

        updateProgress() {
          if (!this.track || !this.progress || !this.progressThumb) return;
          const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const visibleRatio = Math.min(1, this.track.clientWidth / this.track.scrollWidth);
          const scrollRatio = maximumScroll > 0 ? this.track.scrollLeft / maximumScroll : 0;
          const thumbWidth = Math.max(44, this.progress.clientWidth * visibleRatio);
          const maximumTravel = Math.max(0, this.progress.clientWidth - thumbWidth);
          this.progressThumb.style.width = `${thumbWidth}px`;
          this.progressThumb.style.transform = `translateX(${maximumTravel * scrollRatio}px)`;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muas-v10-banner-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('muas-v10-banner-products')) {
    customElements.define(
      'muas-v10-banner-products',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-v10-track]');
          this.previousButton = this.querySelector('[data-v10-prev]');
          this.nextButton = this.querySelector('[data-v10-next]');
          this.progress = this.querySelector('[data-v10-progress]');
          if (!this.track || this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          this.onPointerDown = this.onPointerDown.bind(this);
          this.onPointerMove = this.onPointerMove.bind(this);
          this.onPointerUp = this.onPointerUp.bind(this);
          this.onClick = this.onClick.bind(this);
          this.updateProgress = this.updateProgress.bind(this);

          this.track.addEventListener('pointerdown', this.onPointerDown);
          this.track.addEventListener('pointermove', this.onPointerMove);
          this.track.addEventListener('pointerup', this.onPointerUp);
          this.track.addEventListener('pointercancel', this.onPointerUp);
          this.track.addEventListener('click', this.onClick, true);
          this.track.addEventListener('scroll', this.updateProgress, { passive: true });
          if (this.previousButton) this.previousButton.addEventListener('click', () => this.move(-1));
          if (this.nextButton) this.nextButton.addEventListener('click', () => this.move(1));
          this.updateProgress();
        }

        onPointerDown(event) {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.dragging = true;
          this.moved = false;
          this.startX = event.clientX;
          this.startScroll = this.track.scrollLeft;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
        }

        onPointerMove(event) {
          if (!this.dragging) return;
          const distance = event.clientX - this.startX;
          if (Math.abs(distance) > 6) this.moved = true;
          this.track.scrollLeft = this.startScroll - distance;
        }

        onPointerUp(event) {
          if (!this.dragging) return;
          this.dragging = false;
          this.suppressClick = this.moved;
          this.track.classList.remove('is-dragging');
          if (this.track.hasPointerCapture(event.pointerId)) {
            this.track.releasePointerCapture(event.pointerId);
          }
          window.setTimeout(() => {
            this.suppressClick = false;
          }, 0);
        }

        onClick(event) {
          if (!this.suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
        }

        move(direction) {
          const card = this.track.querySelector('[data-v10-card]');
          if (!card) return;
          const gap = Number.parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
        }

        updateProgress() {
          if (!this.progress) return;
          const maxScroll = this.track.scrollWidth - this.track.clientWidth;
          const visible = Math.min(100, (this.track.clientWidth / this.track.scrollWidth) * 100);
          const position = maxScroll > 0 ? (this.track.scrollLeft / maxScroll) * (100 - visible) : 0;
          this.progress.style.width = `${visible}%`;
          this.progress.style.left = `${position}%`;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muas-v10-category-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('muas-v10-category-carousel')) {
    customElements.define(
      'muas-v10-category-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-v10-track]');
          this.cards = Array.from(this.querySelectorAll('[data-v10-card]'));
          this.dots = Array.from(this.querySelectorAll('[data-v10-dot]'));
          if (!this.track || this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          this.onPointerDown = this.onPointerDown.bind(this);
          this.onPointerMove = this.onPointerMove.bind(this);
          this.onPointerUp = this.onPointerUp.bind(this);
          this.onClick = this.onClick.bind(this);
          this.onTouchStart = this.onTouchStart.bind(this);
          this.onTouchMove = this.onTouchMove.bind(this);
          this.onTouchEnd = this.onTouchEnd.bind(this);
          this.updateDot = this.updateDot.bind(this);

          this.track.addEventListener('pointerdown', this.onPointerDown);
          this.track.addEventListener('pointermove', this.onPointerMove);
          this.track.addEventListener('pointerup', this.onPointerUp);
          this.track.addEventListener('pointercancel', this.onPointerUp);
          this.track.addEventListener('touchstart', this.onTouchStart, { passive: true });
          this.track.addEventListener('touchmove', this.onTouchMove, { passive: false });
          this.track.addEventListener('touchend', this.onTouchEnd, { passive: true });
          this.track.addEventListener('touchcancel', this.onTouchEnd, { passive: true });
          this.track.addEventListener('click', this.onClick, true);
          this.track.addEventListener('scroll', this.updateDot, { passive: true });

          this.dots.forEach((dot) => {
            dot.addEventListener('click', () => this.goTo(Number(dot.dataset.v10Dot)));
          });
        }

        onPointerDown(event) {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.dragging = true;
          this.moved = false;
          this.startX = event.clientX;
          this.startScroll = this.track.scrollLeft;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
        }

        onPointerMove(event) {
          if (!this.dragging) return;
          const distance = event.clientX - this.startX;
          if (Math.abs(distance) > 6) this.moved = true;
          this.track.scrollLeft = this.startScroll - distance;
        }

        onPointerUp(event) {
          if (!this.dragging) return;
          this.dragging = false;
          this.suppressClick = this.moved;
          this.track.classList.remove('is-dragging');
          if (this.track.hasPointerCapture(event.pointerId)) {
            this.track.releasePointerCapture(event.pointerId);
          }
          window.setTimeout(() => {
            this.suppressClick = false;
          }, 0);
        }

        onTouchStart(event) {
          if (event.touches.length !== 1) return;
          const touch = event.touches[0];
          this.touchStartX = touch.clientX;
          this.touchStartY = touch.clientY;
          this.touchStartScroll = this.track.scrollLeft;
          this.touchDirection = null;
          this.touchMoved = false;
        }

        onTouchMove(event) {
          if (event.touches.length !== 1) return;
          const touch = event.touches[0];
          const distanceX = touch.clientX - this.touchStartX;
          const distanceY = touch.clientY - this.touchStartY;

          if (!this.touchDirection) {
            if (Math.max(Math.abs(distanceX), Math.abs(distanceY)) < 8) return;
            this.touchDirection = Math.abs(distanceX) > Math.abs(distanceY) ? 'horizontal' : 'vertical';
          }

          if (this.touchDirection !== 'horizontal') return;

          event.preventDefault();
          this.touchMoved = true;
          this.track.scrollLeft = this.touchStartScroll - distanceX;
        }

        onTouchEnd() {
          if (this.touchDirection === 'horizontal' && this.touchMoved) {
            this.suppressClick = true;
            window.setTimeout(() => {
              this.suppressClick = false;
            }, 250);
          }

          this.touchDirection = null;
          this.touchMoved = false;
        }

        onClick(event) {
          if (!this.suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
        }

        goTo(index) {
          const card = this.cards[index];
          if (!card) return;
          this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        }

        updateDot() {
          if (!this.cards.length || !this.dots.length) return;
          const center = this.track.scrollLeft + this.track.clientWidth / 2;
          let activeIndex = 0;
          let activeDistance = Number.POSITIVE_INFINITY;

          this.cards.forEach((card, index) => {
            const cardCenter = card.offsetLeft + card.offsetWidth / 2;
            const distance = Math.abs(cardCenter - center);
            if (distance < activeDistance) {
              activeDistance = distance;
              activeIndex = index;
            }
          });

          this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muas-v10-product-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('muas-v10-product-carousel')) {
    customElements.define(
      'muas-v10-product-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-v10-track]');
          this.previousButton = this.querySelector('[data-v10-prev]');
          this.nextButton = this.querySelector('[data-v10-next]');
          this.progress = this.querySelector('[data-v10-progress]');
          if (!this.track || this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          this.onPointerDown = this.onPointerDown.bind(this);
          this.onPointerMove = this.onPointerMove.bind(this);
          this.onPointerUp = this.onPointerUp.bind(this);
          this.onClick = this.onClick.bind(this);
          this.updateProgress = this.updateProgress.bind(this);

          this.track.addEventListener('pointerdown', this.onPointerDown);
          this.track.addEventListener('pointermove', this.onPointerMove);
          this.track.addEventListener('pointerup', this.onPointerUp);
          this.track.addEventListener('pointercancel', this.onPointerUp);
          this.track.addEventListener('click', this.onClick, true);
          this.track.addEventListener('scroll', this.updateProgress, { passive: true });
          if (this.previousButton) this.previousButton.addEventListener('click', () => this.move(-1));
          if (this.nextButton) this.nextButton.addEventListener('click', () => this.move(1));
          this.updateProgress();
        }

        onPointerDown(event) {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.dragging = true;
          this.moved = false;
          this.startX = event.clientX;
          this.startScroll = this.track.scrollLeft;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
        }

        onPointerMove(event) {
          if (!this.dragging) return;
          const distance = event.clientX - this.startX;
          if (Math.abs(distance) > 6) this.moved = true;
          this.track.scrollLeft = this.startScroll - distance;
        }

        onPointerUp(event) {
          if (!this.dragging) return;
          this.dragging = false;
          this.suppressClick = this.moved;
          this.track.classList.remove('is-dragging');
          if (this.track.hasPointerCapture(event.pointerId)) {
            this.track.releasePointerCapture(event.pointerId);
          }
          window.setTimeout(() => {
            this.suppressClick = false;
          }, 0);
        }

        onClick(event) {
          if (!this.suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
        }

        move(direction) {
          const card = this.track.querySelector('[data-v10-card]');
          if (!card) return;
          const gap = Number.parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
        }

        updateProgress() {
          if (!this.progress) return;
          const maxScroll = this.track.scrollWidth - this.track.clientWidth;
          const visible = Math.min(100, (this.track.clientWidth / this.track.scrollWidth) * 100);
          const position = maxScroll > 0 ? (this.track.scrollLeft / maxScroll) * (100 - visible) : 0;
          this.progress.style.width = `${visible}%`;
          this.progress.style.left = `${position}%`;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
